@if (filters.length>0) {
  <div class="filter-container">
    <h3>Filtros</h3>
    <div>
      <form #f="ngForm">
        <button mat-raised-button color="primary" matTooltip="Actualizar" matTooltipPosition="right" (click)="refresh(f)">
          <mat-icon>refresh</mat-icon>
        </button>
        @for (filter of filters; track filter) {
          <div>
            @if (filter.type === 'input') {
              <mat-form-field appearance="outline">
                <mat-label>{{filter.label}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" [name]="filter.label" ngModel>
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            }
            @if (filter.type === 'select' || filter.type === 'multiSelect') {
              <mat-form-field appearance="outline">
                <mat-label>{{filter.label}}</mat-label>
                <mat-select (selectionChange)="applyFilter($event, 'select', filter)" [multiple]="filter.type === 'multiSelect'" [name]="filter.label" ngModel>
                  @if (filter.type === 'multiSelect') {
                    <mat-option value="Todos">Todos</mat-option>
                  }
                  @for (o of filter.options; track o) {
                    <mat-option [value]="o.value">{{o.viewValue}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (filter.type === 'dateRange') {
              <mat-form-field appearance="outline">
                <mat-label>Fechas</mat-label>
                <mat-date-range-input [rangePicker]="picker" [name]="filter.label" ngModel>
                  <input matStartDate placeholder="Fecha Inicial" (dateChange)="applyFilter($event, 'start')">
                  <input matEndDate placeholder="Fecha Final" (dateChange)="applyFilter($event, 'end')">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            }
          </div>
        }
      </form>
    </div>
  </div>
}

@if (dataSource.filteredData?.length > 0) {
  <div class="table-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">
      @if (selectable) {
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="select-cell">
            <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()" [indeterminate]="isPartiallySelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="select-cell">
            <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? toggleRow(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>
      }
      @for (col of tableData.columns; track col) {
        <ng-container [matColumnDef]="col.columnKey">
          <th mat-header-cell *matHeaderCellDef>
            {{ col.columnName }}
          </th>
          <td mat-cell *matCellDef="let row">
            @if (col.type === 'image') {
              <span class="inv-thumb">
                @if (row[col.columnKey]) {<img [src]="row[col.columnKey]" alt="Foto" loading="lazy" (click)="openImage(row[col.columnKey])">} @else {<mat-icon>image_not_supported</mat-icon>}
              </span>
            } @else if (col.type === 'semaphore') {
              <span class="semaphore" [attr.data-tone]="row['_' + col.columnKey + 'Tone']" [matTooltip]="row['_' + col.columnKey + 'Hint'] || ''">
                <span class="semaphore__dot"></span>{{ row[col.columnKey] }}
              </span>
            } @else if (col.columnKey !== 'actions') {
              {{ row[col.columnKey] }}
            }
            @if (col.columnKey === 'actions') {
              @for (item of row['actions']; track item) {
                <button mat-icon-button [matTooltip]="item.tooltip" matTooltipPosition="above" (click)="onActionClick(item.content)">
                  <mat-icon>{{item.icon}}</mat-icon>
                </button>
              }
            }
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}